import React, { useEffect, useState } from 'react';
import { getLoginStatus } from '@service/login';
import useGo from '@utils/navigate';

const Auth = (props) => {
  const { replace } = useGo();
  const [auth, setAuth] = useState(false);
  const { children } = props;

  useEffect(() => {
    async function checkLogin() {
      let isLogin = false;
      try {
        const { login } = await getLoginStatus();
        isLogin = login;
      } catch (err) {
        console.error(err);
      }
      if (isLogin) {
        setAuth(true);
      } else {
        setAuth(false);
        replace(
          '/login',
          {
            redirectUrl: encodeURIComponent(window.location.href),
          },
          { isAppendQuery: false },
        );
      }
    }
    checkLogin();
  }, []);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{auth && children}</>;
};

export default Auth;
